import { render } from "./AdminSavePage.vue?vue&type=template&id=ea41781c"
import script from "./AdminSavePage.vue?vue&type=script&lang=js"
export * from "./AdminSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script